<div class="container-fluid row col-12 no-gutters" style="font-size: 14px;">
  <div class="col-xl-9 col-md-8 col-sm-12 no-gutters">
    <div class="col-9 m-auto" [formGroup]="scorecardForm">
      <h6 class="w-100 title">Application Description</h6>
      <div class="w-100 mt-3 text-normal">Supplier Scorecard for Onshore supplier performance.</div>
      <div class="w-100 mt-3 text-normal">Supplier Portal is a one stop for suppliers to find training material on GE applications and Document templates.</div>
      <h6 class="w-100 title mt-3">Registration Quesions</h6>
      <div class="mt-3 text-normal">User Name
        <span _ngcontent-xqt-c8="" style="color: red;">* </span>
      </div>
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput required formControlName="userName" maxlength="50" readonly>
        <mat-hint align="end">{{scorecardForm.controls.userName.value.length || 0}} / 50</mat-hint>
        <mat-error>{{scorecardForm.controls.userName.errors?.message}}</mat-error>
      </mat-form-field>

      <div class="text-normal mt-3">Full Name
        <span _ngcontent-xqt-c8="" style="color: red;">* </span>
      </div>
      <mat-form-field appearance="outline" class=" w-100">
        <input matInput required formControlName="fullName" maxlength="50" readonly>
        <mat-hint align="end">{{scorecardForm.controls.fullName.value.length || 0}} / 50</mat-hint>
        <mat-error>{{scorecardForm.controls.fullName.errors?.message}}</mat-error>
      </mat-form-field>

      <div class="text-normal mt-3">GE Contact Name
        <span _ngcontent-xqt-c8="" style="color: red;">* </span>
      </div>
      <mat-form-field floatLabel="never" appearance="outline" class="w-100">
        <input formControlName="geContactSso" name="geContactSso" matInput #geContactSso placeholder="" maxlength="50">
        <mat-icon matSuffix (click)="searchSSO($event)" style="cursor: pointer;">search</mat-icon>
      </mat-form-field>

      <div class="text-normal mt-3">Request Type
        <span _ngcontent-xqt-c8="" style="color: red;">* </span>
      </div>
      <mat-form-field floatLabel="never" appearance="outline" class="w-100">
        <mat-select formControlName="business" placeholder="Select Business"
          (selectionChange)="selectBusiness($event)">
          <mat-option *ngFor="let item of businesses" [value]="item">
            {{item}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div *ngIf="isRSPBusiness">
        <div class="text-normal mt-3">Supplier SSO Email
          <span _ngcontent-xqt-c8="" style="color: red;">* </span>
        </div>
        <mat-form-field appearance="outline" class=" w-100">
          <input matInput required #email formControlName="email">
          <mat-hint align="end">{{scorecardForm.controls.email.value.length || 0}} / 50</mat-hint>
          <mat-error *ngIf="scorecardForm.controls.email.invalid">This field is required</mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="!isRSPBusiness">
        <div class="text-normal mt-3">Please provide the Purchase Order number (and/or eRFQ number) that you require
          access to
          <span _ngcontent-xqt-c8="" style="color: red;">* </span>
        </div>
        <mat-form-field appearance="outline" class=" w-100">
          <input matInput required formControlName="purchaseOrder">
          <mat-hint align="end">{{scorecardForm.controls.purchaseOrder.value.length || 0}} / 50</mat-hint>
          <mat-error>{{scorecardForm.controls.purchaseOrder.errors?.message}}</mat-error>
        </mat-form-field>

        <div class="text-normal mt-3">Supplier GSL
          <span _ngcontent-xqt-c8="" style="color: red;">* </span>
        </div>
        <mat-form-field appearance="outline" class=" w-100">
          <input matInput required formControlName="supplierGSL">
          <mat-hint align="end">{{scorecardForm.controls.supplierGSL.value.length || 0}} / 50</mat-hint>
          <mat-error *ngIf="scorecardForm.controls.supplierGSL.invalid">This field is required</mat-error>
        </mat-form-field>
  
        <div class="text-normal mt-3">SRM Token
          <span _ngcontent-xqt-c8="" style="color: red;">* </span>
        </div>
        <mat-form-field appearance="outline" class=" w-100">
          <input matInput required formControlName="srmToken">
          <mat-hint align="end">{{scorecardForm.controls.srmToken.value.length || 0}} / 50</mat-hint>
          <mat-error *ngIf="scorecardForm.controls.srmToken.invalid">This field is required</mat-error>
        </mat-form-field>
      </div>

      <div class="row no-gutters col-12 d-flex align-items-center justify-content-center pt-4">
        <button class="btn btn-primary btn-vernova button col-xl-5 col-md-6 col-sm-12 col-12 text-normal" style="font-size: 18px;"
          (click)="submit()">
          <span>
            Request Access
          </span>
        </button>
      </div>
    </div>
  </div>
  <div class="col-12 col-sm-12 col-md-4 col-xl-3 no-gutters">
    <div class="row no-gutters col-12 align-items-center justify-content-center d-none d-sm-block">
      <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
        <span>
          Go To Application
          <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
        </span>
      </button>
    </div>
    <hr>
    <div class="col-12">
      <h6>
        <strong class="mt-3 text-lable">
          Support
        </strong>
      </h6>
      <div class="col-12 mt-3 p-0 text-normal d-block d-sm-none">
        <button class="btn btn-primary btn-vernova button col-12" style="font-size: 18px;" (click)="goToApplication()">
          <span>
            Go To Application
            <i class='fa fa-sign-out pl-2' style="color: #fff;"></i>
          </span>
        </button>
        <hr>
      </div>
      <div class="col-12 mt-3 text-normal p-0">
        GE Renewable Energy Supplier Support
        (<a href="mailto:chakravarthi.rebbapragada@ge.com"
          style="word-wrap: break-word;" class="text-highlight">~GE Vernova Supplier Support</a>)
      </div>
    </div>
    <hr>
    <div class="d-flex col-12 no-gutters">
      <h6><strong class="mt-3 text-lable">Request Created</strong></h6>
      <div id="refresh" class="header-links ml-auto" style="padding-right: 2px;">
        <i class="fa fa-refresh" style="cursor: pointer; color: #005E60;" (click)="getListTicket($event)"></i>
      </div>
    </div>
    <div class="col-12 border-box no-gutters d-flex align-items-center justify-content-center">
      <div class="col-11 no-gutters">
        <div class="col-12 text-normal no-gutters" *ngFor="let item of request; let first = first; let last = last">
          <div class="pt-3 col-12" *ngIf="first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="col-12" *ngIf="!first">
            <div>
              Request submitted at
            </div>
            <div>
              {{item?.date | date:'medium'}}
            </div>
          </div>
          <div class="py-2">
            <div>
              Request ID number:
            </div>
            <div>{{item?.number}}</div>
          </div>
          <div class="pb-3" *ngIf="last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <div *ngIf="!last && item?.status">
            <div>Status: </div>
            <div>{{item?.status}}</div>
          </div>
          <hr *ngIf="!last">
        </div>
      </div>
    </div>
  </div>
</div>